/**
 * 认证相关接口
 */
const PREFIX = 'checkmall-user'
let shiroApi = {
  /**
   * 接口模块 前缀
   */
  prefix: PREFIX,
  url: {
    //获取验证码
    captcha: '/api/auth/captcha.jpg',
    //登录
    login: '/api/auth/user/login',
  },
}
export default shiroApi
